//RAW DATA
export const GET_SELECTED_DEVICE_ID_DATA = 'GET_DEVICE_ID_DATA';
export const ERROR_SELECTED_DEVICE_ID_DATA = 'ERROR_DEVICE_ID_DATA';
export const CLEAR_SELECTED_DEVICE_ID_DATA = 'CLEAR_DEVICE_ID_DATA';
export const SUBMIT_SUCCESS = 'SUBMIT_SUCCESS';
export const SUBMIT_FAIL = 'SUBMIT_FAIL';
export const UPDATE_DEVICE_DATA = 'UPDATE_DEVICE_DATA'; // New action for immediate data update

export const GET_SELECTED_DEVICE_LOGIN = 'GET_DEVICE_LOGIN';
export const ERROR_SELECTED_DEVICE_LOGIN = 'ERROR_DEVICE_LOGIN';
export const CLEAR_SELECTED_DEVICE_LOGIN = 'CLEAR_DEVICE_LOGIN';

// Meta Info History Constants
export const GET_META_INFO_HISTORY_REQUEST = 'GET_META_INFO_HISTORY_REQUEST';
export const GET_META_INFO_HISTORY_SUCCESS = 'GET_META_INFO_HISTORY_SUCCESS';
export const GET_META_INFO_HISTORY_FAIL = 'GET_META_INFO_HISTORY_FAIL';